// Decides whether landing on the plan list should skip straight into creating
// the user's first plan. A brand-new user gains nothing from an empty list;
// /plans/new drops them directly into a fresh plan (and its first-experience
// flow) when only the blank template exists.
// Pure module (no Angular imports) so it can be unit-tested in the Node
// Jasmine harness.

export interface FirstPlanAutostartInput {
    myCount: number;
    sharedCount: number;
    deletedCount: number;
    // The list service resolves an empty array when a request FAILS, so zero
    // counts alone do not prove the account is empty. Auto-starting creates a
    // real plan on the server, so it must never run on a failed load.
    allListsLoaded: boolean;
    // True once we have auto-started during this session. Without this a user
    // who backs out of the new-plan flow could never reach the list at all.
    alreadyAutoStarted: boolean;
}

export function shouldAutoStartFirstPlan(input: FirstPlanAutostartInput): boolean {
    if (!input.allListsLoaded || input.alreadyAutoStarted) {
        return false;
    }
    // Archived plans still count as history: a user who archived everything
    // wants their list (and the Archived filter), not a forced new plan.
    return input.myCount === 0 && input.sharedCount === 0 && input.deletedCount === 0;
}
